import axios from '../axios-init';

export const login = params => {
    return axios.post(`/invite/inviteLogin`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const validateRegister = params => {
    return axios.post(`/invite/validateInvitedId`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const register = params => {
    return axios.post(`/invite/inviteRegister`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const changePassword = params => {
    return axios.post(`/invitation/changePwd`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const changeUserInfo = params=>{
    return axios.post(`/user/modifyPhoneNumber`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getCurrentUser = params=>{
    return axios.post(`/user/currentUser`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const logout = params=>{
    return axios.post(`/invitation/logout`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getDoctorHome = params=>{
    return axios.post(`/common/getDoctorHomeData`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getNurseHome = params=>{
    return axios.post(`/statistics/statisticsNurseData`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const requestForgetPassword = params=>{
    return axios.post(`/passwordResetRequest/sendResetPasswordEmail`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const validateResetPassword = params=>{
    return axios.post(`/passwordResetRequest/validateResetId`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const resetPassword = params=>{
    return axios.post(`/passwordResetRequest/resetPassword`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};




// WEBPACK FOOTER //
// ./src/api/securityService.js